import { makeAutoObservable } from 'mobx'
import { PageLayoutStore } from 'shared/layout'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { ContactsMenuStore } from 'pages/contacts/ui/ContactsMenu'
import { SegmentModalStore } from 'pages/contacts/ui/ContactsMenu/ui/SegmentModal'

export class ContactsPageLayoutStore {
  private _pageLayoutStore = new PageLayoutStore()
  private readonly _segmentModalStore: SegmentModalStore
  private readonly _contactsMenuStore: ContactsMenuStore

  constructor(private _entities: IEntitiesStore) {
    this._segmentModalStore = new SegmentModalStore(this._entities)
    this._contactsMenuStore = new ContactsMenuStore(
      this._segmentModalStore,
      this._pageLayoutStore,
      this._entities
    )

    makeAutoObservable(this)
  }

  get entities() {
    return this._entities
  }

  get callStore() {
    return this._entities.callStore
  }

  get pageLayoutStore() {
    return this._pageLayoutStore
  }

  get contactsMenuStore() {
    return this._contactsMenuStore
  }

  get segmentModalStore() {
    return this._segmentModalStore
  }

  dispose = () => {}
}
